import React from "react";
import { createGlobalStyle } from "styled-components";
import { motion } from "framer-motion";
import settings from "@src/settings";
import styled, { ThemeProvider } from "styled-components";
import BaseGrid from "./BaseGrid";

interface Props {
	showGrid?: boolean;
	animateIn?: boolean;
	children?: React.ReactNode;
}

const Frame = styled(motion.main)`
	position: relative;
	overflow: hidden;
`;

const animation = {
	frame: {
		shown: {
			opacity: 1,
			transition: { duration: 1.4 },
		},
		hidden: {
			opacity: 0,
			transition: { duration: 1 },
		},
	},
};

export const GlobalStyle = createGlobalStyle`
	html, body{
		font-family: "Noto Sans JP", "Montserrat", sans-serif;
		font-size: ${settings.baseGrid.fontSize}px;
		line-height: 1.75;
	}
`;
const theme = {
	breakpoints: {
		xs: "0px",
		sm: `${settings.breakpoint.sm}px`,
		md: `${settings.breakpoint.md}px`,
		lg: `${settings.breakpoint.lg}px`,
		xl: `${settings.breakpoint.xl}px`,
		xxl: `${settings.breakpoint.xxl}px`,
	},
};
const Layout: React.FC<Props> = (props) => {
	const { showGrid, children, animateIn } = props;
	return (
		<Frame
			initial={animateIn ? "hidden" : "shown"}
			animate={animateIn ? "shown" : undefined}
			variants={animation.frame}
		>
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				{showGrid == true && <BaseGrid />}
				{children}
			</ThemeProvider>
		</Frame>
	);
};

export default Layout;
